import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  stockTransferNo: {
    name: "stockTransferNo",
    label: "Stock Transfer No",
    type: "text",
    editable: false,
    disabled: true, 
    maxLength: 20,
    xs: 3,
  },
  fromWarehouseCode: {
    name: "fromWarehouseCode",
    label: "From Warehouse Code",
    type: "select",
    errorMsg: "From Warehouse Code is required.",
    required: true,
    maxLength: 20,
    xs: 3,
  },
  warehouseCode: {
    name: "warehouseCode",
    label: "To Warehouse Code",
    type: "select",
    errorMsg: "To Warehouse Code is required.",
    required: true,
    maxLength: 20,
    xs: 3,
  },
  customerCode: {
    type: "text",
    name: "customerCode",
    label: "Customer Code",
    errorMsg: "Customer Code is required",
    required: true,
    disabled: true,
    xs: 3,
  },
  reasonCode: {
    name: "reasonCode",
    label: "Reason",
    type: "text",
    errorMsg: "Reason is required",
    required: true,
    maxLength: 20,
    xs: 3,
  },
  uploadDivision: {
    name: "uploadDivision",
    label: "Division File Required",
    type: "switch",
    default: true,
    xs: 3,
  },
};

const { stockTransferNo, reasonCode, fromWarehouseCode, warehouseCode, customerCode, uploadDivision } = formField;

export const formRender = [[stockTransferNo, customerCode, reasonCode], [fromWarehouseCode, warehouseCode, uploadDivision]/*, [remark]*/];

export const initialValues = getInitialValues(formField);

export const stockTransferValidation = Yup.object().shape({
  [stockTransferNo.name]: Yup.string().nullable().max(stockTransferNo.maxLength),
  [reasonCode.name]: Yup.string().nullable().required(reasonCode.errorMsg).max(reasonCode.maxLength),
  [warehouseCode.name]: Yup.string().nullable().max(warehouseCode.maxLength).required(warehouseCode.errorMsg),
  [fromWarehouseCode.name]: Yup.string().nullable().max(fromWarehouseCode.maxLength).required(fromWarehouseCode.errorMsg),
  [customerCode.name]: Yup.string().nullable().required(customerCode.errorMsg),
});
